// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"ExpandControl_r-mobile__PgN6k","r-not-mobile":"ExpandControl_r-not-mobile__tFWwv","checkbox":"ExpandControl_checkbox__o6Rzr","label":"ExpandControl_label__7508h"};